import playInactive from '../images/player/media-play-disabled.png';
import playInactive2x from '../images/player/media-play-disabled@2x.png';
import playInactive3x from '../images/player/media-play-disabled@3x.png';
import playActive from '../images/player/media-play.png';
import playActive2x from '../images/player/media-play@2x.png';
import playActive3x from '../images/player/media-play@3x.png';
import playPressed from '../images/player/media-play-pressed.png';
import playPressed2x from '../images/player/media-play-pressed@2x.png';
import playPressed3x from '../images/player/media-play-pressed@3x.png';
import pauseInactive from '../images/player/media-pause-disabled.png';
import pauseInactive2x from '../images/player/media-pause-disabled@2x.png';
import pauseInactive3x from '../images/player/media-pause-disabled@3x.png';
import pauseActive from '../images/player/media-pause.png';
import pauseActive2x from '../images/player/media-pause@2x.png';
import pauseActive3x from '../images/player/media-pause@3x.png';
import pausePressed from '../images/player/media-pause-pressed.png';
import pausePressed2x from '../images/player/media-pause-pressed@2x.png';
import pausePressed3x from '../images/player/media-pause-pressed@3x.png';

const getImageSrcSet = (baseName) => {
    switch (baseName) {
      case 'play':
        return `${playInactive} 1x, ${playInactive2x} 2x, ${playInactive3x} 3x`;
      case 'play-active':
        return `${playActive} 1x, ${playActive2x} 2x, ${playActive3x} 3x`;
      case 'play-pressed':
        return `${playPressed} 1x, ${playPressed2x} 2x, ${playPressed3x} 3x`;
      case 'pause':
        return `${pauseInactive} 1x, ${pauseInactive2x} 2x, ${pauseInactive3x} 3x`;
      case 'pause-active':
        return `${pauseActive} 1x, ${pauseActive2x} 2x, ${pauseActive3x} 3x`;
      case 'pause-pressed':
        return `${pausePressed} 1x, ${pausePressed2x} 2x, ${pausePressed3x} 3x`;
      default:
        return '';
    }
  };

  export const getImageSrcSetForCurrentState = (isPlaying, buttonState) => {
    if (isPlaying) {
      switch (buttonState) {
        case 'active':
          return getImageSrcSet('pause-active');
        case 'pressed':
          return getImageSrcSet('pause-pressed');
        case 'inactive':
        default:
          return getImageSrcSet('pause');
      }
    } else {
      switch (buttonState) {
        case 'active':
          return getImageSrcSet('play-active');
        case 'pressed':
          return getImageSrcSet('play-pressed');
        case 'inactive':
        default:
          return getImageSrcSet('play');
      }
    }
  };


  export const getDefaultSrc = (isPlaying, buttonState) => {
    if (isPlaying) {
      switch (buttonState) {
        case 'active':
          return pauseActive;
        case 'pressed':
          return pausePressed;
        case 'inactive':
        default:
          return pauseInactive;
      }
    } else {
      switch (buttonState) {
        case 'active':
          return playActive;
        case 'pressed':
          return playPressed;
        case 'inactive':
        default:
          return playInactive;
      }
    }
  };